// Copyright (c) 2025, Quantum Xchange, Inc.
'use strict'

import axios from 'axios'

import { RESET_ALERT_MODAL, SET_ALERT_MODAL } from 'js/contexts/uiContext'

export const setupAxiosHooks = setUi => {
    axios.interceptors.request.use(config => {
        if (['post', 'put', 'delete'].includes(config.method.toLowerCase())) {
            // Automatically add CSRF Token to all POST, PUT, and DELETE axios requests
            // CSRF token is retrieved from DOM element
            config.headers['X-CSRF-Token'] = document.getElementById('csrf').value
        } else if (config.method.toLowerCase() === 'get') {
            if (config.doNotResetSessionTimeout) {
                // For GET requests, don't update session timeout if doNotResetSessionTimeout is true
                // this is used for requests that are made on a regular interval (like react-query polling)
                config.headers['X-Do-Not-Reset-Session-Timeout'] = 'true'
            }
        }

        return config
    })

    // Error handling
    axios.interceptors.response.use(
        res => {
            return res
        },
        err => {
            if (err.config?.customError) return Promise.reject(err)

            if (err.message === 'Network Error') {
                if (err.config?.noNetworkFailure !== true) {
                    setUi({
                        type: SET_ALERT_MODAL,
                        alertModal: {
                            show: true,
                            title: 'Network Error',
                            message:
                                'Unable to communicate with the system. This may be a temporary problem. Try reloading the page in your browser.',
                            onClose: () => {
                                setUi({ type: RESET_ALERT_MODAL })
                            },
                        },
                    })
                }
            } else if (err.response?.status === 401 && err.config?.noAuthFailure !== true) {
                window.location.href = '/'
            } else if (err.response?.status === 403 && err.response?.data === 'csrf') {
                setUi({
                    type: SET_ALERT_MODAL,
                    alertModal: {
                        show: true,
                        title: 'New Session Detected',
                        message: `Your request did not complete successfully because a new session was detected. Please resubmit your request after clicking 'OK'`,
                        onClose: () => {
                            setUi({ type: RESET_ALERT_MODAL })
                            window.location.reload(true)
                        },
                    },
                })
            } else if (err.response?.status === 403 && err.config?.noAuthFailure !== true) {
                setUi({
                    type: SET_ALERT_MODAL,
                    alertModal: {
                        show: true,
                        title: 'Permission Error',
                        message: 'Your permissions do not allow you to perform this operation',
                        onClose: () => {
                            setUi({ type: RESET_ALERT_MODAL })
                            window.location.href = '/'
                        },
                    },
                })
            }

            return Promise.reject(err)
        }
    )
}
